module.exports = __webpack_public_path__ + "static/img/Knights.f7cdcfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Knights.svg
// module id = NDae
// module chunks = 0